import { Component, OnInit } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';

import { NewService } from './../../services/new/new.service';
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  news: any[] = [];
  public filter: any = { title : ''};
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = true;
  public responsive: boolean = false;
  public config = {
    id: 'pagination',
    itemsPerPage: 6,
    currentPage: 0
  };
  public labels: any = {
    previousLabel: 'Anterior',
    nextLabel: 'Siguiente',
    screenReaderPaginationLabel: 'Paginaión',
    screenReaderPageLabel: 'Pagina',
    screenReaderCurrentLabel: `Te encuentras aqui`
  };



  constructor(
    private newService:NewService
  ) { }

  ngOnInit() {

    this.getNews();

  }

  getNews(){
    this.newService.getNews().subscribe(news => {
      news.forEach(n => {
        n.date = n.publicationDate;
        this.news.push(n);
      })

    })
  }



  onPageChange(number: number) {
    console.log('change to page', number);
    this.config.currentPage = number;
  }

}
